"use client";

import { getAvatarToneClass, getInitials } from "@/utils/avatar.utils";
import { cn } from "@/lib/utils";
interface ContactAvatarProps {
  name: string;
  photoUrl?: string | null;
  sizeClass: string;
  textClass: string;
}
export function ContactAvatar({
  name,
  photoUrl,
  sizeClass,
  textClass
}: ContactAvatarProps) {
  if (photoUrl) {
    return <img src={photoUrl} alt={name} className={cn(sizeClass, "rounded-full flex-shrink-0 object-cover")} />;
  }
  return <div className={cn(sizeClass, textClass, getAvatarToneClass(name), "rounded-full flex-shrink-0 flex items-center justify-center text-tag-ink font-medium")} data-sentry-component="ContactAvatar" data-sentry-source-file="ContactAvatar.tsx">
            {getInitials(name)}
        </div>;
}